import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { auth as authApi, business as bizApi } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      nav("/login");
      return;
    }

    (async () => {
      try {
        const { data } = await authApi.emergentExchange(sessionId);
        if (data.session_token) localStorage.setItem("rq_token", data.session_token);
        window.history.replaceState({}, "", "/dashboard");
        await refresh();
        toast.success("Signed in with Google");
        // Route new users straight to onboarding to avoid the ProtectedShell round-trip flicker
        let dest = "/dashboard";
        try {
          const { data: biz } = await bizApi.get();
          if (!biz?.onboarded) dest = "/onboarding";
        } catch { dest = "/onboarding"; }
        nav(dest, { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed. Try again.");
        nav("/login", { replace: true });
      }
    })();
  }, [location.hash, nav, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F1F5F9]">
      <div className="flex flex-col items-center gap-3 text-[#001F3F]">
        <Loader2 className="animate-spin text-[#2563EB]" size={32} />
        <div className="text-sm text-[#64748B]">Signing you in…</div>
      </div>
    </div>
  );
}
